@if (isRequired) {
	{{ label }} <span class="required-asterisk" aria-hidden="true">*</span
	><span class="sr-only">Required</span>
} @else {
	{{ label }} <span class="sr-only">Optional</span>
}
